import React from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import i18next from 'v2/helpers/i18n';
import {
  refineReviewAcceptAllSx,
  refineReviewActionsSx,
  refineReviewBannerSx,
  refineReviewBodySx,
  refineReviewCopySx,
  refineReviewIconSx,
  refineReviewRejectAllSx,
  refineReviewTitleSx,
} from './refineStyle';

const RefineChangesBanner = ({
  count = 0,
  instruction = '',
  disabled = false,
  onRejectAll = () => null,
  onAcceptAll = () => null,
}) => {
  if (!count) return null;

  return (
    <Box
      role="status"
      data-testid="boq-refine-review-banner"
      sx={refineReviewBannerSx}
    >
      <Box sx={refineReviewIconSx}>
        <DescriptionOutlinedIcon fontSize="small" aria-hidden />
      </Box>
      <Box sx={refineReviewCopySx}>
        <Typography sx={refineReviewTitleSx}>
          {i18next.t('boq-refine-review-title', { count })}
        </Typography>
        <Typography sx={refineReviewBodySx}>
          {i18next.t('boq-refine-review-body', { instruction })}
        </Typography>
      </Box>
      <Box sx={refineReviewActionsSx}>
        <Button
          variant="text"
          disabled={disabled}
          onClick={onRejectAll}
          sx={refineReviewRejectAllSx}
        >
          {i18next.t('boq-refine-review-reject-all')}
        </Button>
        <Button
          variant="outlined"
          disabled={disabled}
          onClick={onAcceptAll}
          startIcon={<CheckIcon />}
          sx={refineReviewAcceptAllSx}
        >
          {i18next.t('boq-refine-review-accept-all')}
        </Button>
      </Box>
    </Box>
  );
};

export default RefineChangesBanner;
